import React, { useEffect, useRef, useState } from 'react';
import CustomText from '../../../../Common/customComponents/CustomText.tsx';
import { TextButton } from '../../../../../components';
import ButtonMoveUp from '/assets/icon/global/button-move-up.svg';
import ButtonMoveDown from '/assets/icon/global/button-move-down.svg';
import ButtonInnerX from '/assets/icon/global/button-inner-x.svg';
import UserSearchModal from '../../../Setting/modal/UserSearchModal.tsx';
import FormApprovalRow from './FormApprovalRow.tsx';
import FormApprovalRowForExtend from './FormApprovalRowForExtend.tsx';

interface IProps {
  data: any;
  setData: any;
  handleChange?: any;
  formCode?: string;
  isReadOnly: boolean;
  onRefresh?: () => void;
  isFinish: boolean;
}

const FormApproval = (props: IProps) => {
  const [checkedSeq, setCheckedSeq] = useState<number | null>(null);
  const [initCloneData, setInitCloneData] = useState<any>(null);

  //reset을 위해 초기 값 저장
  useEffect(() => {
    if (!initCloneData && props.data?.approvalMVOList) {
      setInitCloneData(JSON.parse(JSON.stringify(props.data.approvalMVOList)));
    }
  }, [props.data]);

  const getApprovalKey = (item: any): number | null => {
    return item?.approvalMSeq ?? item?.settingApprovalModeSeq ?? null;
  };

  const moveUpApproval = (targetType: string) => {
    if (checkedSeq == null) return;

    props.setData((prev: any) => {
      const approvalMVOList: any[] = [...(prev?.approvalMVOList ?? [])];

      // targetType 인 항목들의 "원본 리스트" 인덱스만 뽑는다
      const typeIndexes = approvalMVOList
        .map((item, idx) => (item?.approvalType === targetType ? idx : -1))
        .filter((idx) => idx >= 0);

      // 체크된 항목이 targetType 그룹에서 몇 번째인지
      const pos = typeIndexes.findIndex(
        (idx) => getApprovalKey(approvalMVOList[idx]) === checkedSeq
      );
      if (pos <= 0) return prev; // 없거나, 이미 맨 위

      const i1 = typeIndexes[pos];
      const i2 = typeIndexes[pos - 1];

      // swap
      [approvalMVOList[i1], approvalMVOList[i2]] = [approvalMVOList[i2], approvalMVOList[i1]];

      // oder 재정렬 (targetType 그룹 안에서만 1..N)
      let order = 1;
      for (const idx of typeIndexes) {
        const item = approvalMVOList[idx];
        approvalMVOList[idx] = { ...item, oder: order++ };
      }

      return { ...prev, approvalMVOList };
    });
  };

  const moveDownApproval = (targetType: string) => {
    if (checkedSeq == null) return;

    props.setData((prev: any) => {
      const approvalMVOList: any[] = [...(prev?.approvalMVOList ?? [])];

      const typeIndexes = approvalMVOList
        .map((item, idx) => (item?.approvalType === targetType ? idx : -1))
        .filter((idx) => idx >= 0);

      const pos = typeIndexes.findIndex(
        (idx) => getApprovalKey(approvalMVOList[idx]) === checkedSeq
      );
      if (pos === -1 || pos >= typeIndexes.length - 1) return prev; // 없거나, 이미 맨 아래

      const i1 = typeIndexes[pos];
      const i2 = typeIndexes[pos + 1];

      [approvalMVOList[i1], approvalMVOList[i2]] = [approvalMVOList[i2], approvalMVOList[i1]];

      let order = 1;
      for (const idx of typeIndexes) {
        const item = approvalMVOList[idx];
        approvalMVOList[idx] = { ...item, oder: order++ };
      }

      return { ...prev, approvalMVOList };
    });
  };

  const delApproval = () => {
    if (checkedSeq == null) return;

    props.setData((prev: any) => {
      const list: any[] = [...(prev?.approvalMVOList ?? [])];

      const target = list.find((x) => getApprovalKey(x) === checkedSeq);
      if (!target) return prev;

      const targetType = target.approvalType;

      const nextList = list.filter((x) => getApprovalKey(x) !== checkedSeq);

      const sameType = nextList.filter((x) => x.approvalType === targetType);
      sameType.forEach((x, idx) => {
        x.oder = idx + 1;
      });

      return { ...prev, approvalMVOList: nextList };
    });

    setCheckedSeq(null);
  };

  const resetApproval = (approvalType: 'ISSUE' | 'DAILY' | 'CLOSURE') => {
    if (!initCloneData) return;

    props.setData((prev: any) => {
      const current = prev.approvalMVOList ?? [];

      const restored = initCloneData.filter((x: any) => x.approvalType === approvalType);

      const others = current.filter((x: any) => x.approvalType !== approvalType);

      return {
        ...prev,
        approvalMVOList: [...others, ...restored]
      };
    });

    setCheckedSeq(null);
  };

  const onRefresh = () => {
    props.onRefresh?.();
  };

  useEffect(() => {
    console.log(
      'props.data?.approvalMVOList',
      props.data?.approvalMVOList?.filter((item: any) => item.approvalType == 'CLOSURE')
    );
  }, [props.data?.approvalMVOList]);

  return (
    <div>
      {props.data?.approvalMVOList &&
        props.data?.approvalMVOList?.filter((item: any) => item.approvalType == 'ISSUE').length >
          0 && (
          <div className={'approval-area'}>
            <div className={'approval-header'}>
              <span className={'header-title'}>* Issue Open</span>
              {!props.isReadOnly && (
                <div className={'approval-btn-area'}>
                  <div className={'approval-btn-up-down'}>
                    <button
                      className={'header-btn-up'}
                      onClick={() => {
                        moveUpApproval('ISSUE');
                      }}
                    >
                      <img src={ButtonMoveUp} />
                    </button>
                    <button
                      className={'header-btn-down'}
                      onClick={() => {
                        moveDownApproval('ISSUE');
                      }}
                    >
                      <img src={ButtonMoveDown} />
                    </button>
                  </div>
                  <button
                    className={'header-btn'}
                    onClick={() => {
                      resetApproval('ISSUE');
                    }}
                  >
                    Reset
                  </button>
                  <button
                    className={'header-btn'}
                    onClick={() => {
                      delApproval();
                    }}
                  >
                    Deleted
                  </button>
                </div>
              )}
            </div>
            <div className={'approval-body'}>
              <table className={'form-table'}>
                <tbody>
                  {props.data?.approvalMVOList &&
                    props.data?.approvalMVOList
                      .filter((item: any) => item.approvalType == 'ISSUE')
                      .map((approverItem: any, approverIndex: number) => (
                        <FormApprovalRow
                          key={getApprovalKey(approverItem) ?? approverIndex}
                          type={'ISSUE'}
                          approverItem={approverItem}
                          data={props.data}
                          setData={props.setData}
                          checkedSeq={checkedSeq}
                          setCheckedSeq={setCheckedSeq}
                          isReadOnly={props.isReadOnly}
                          isFinish={props.isFinish}
                          disableSearch={
                            approverIndex === 0 &&
                            approverItem.approverCategory === 'Performing Authority'
                          }
                        />
                      ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

      {props.data?.approvalMVOList &&
        props.data?.approvalMVOList?.filter((item: any) => item.approvalType == 'DAILY').length >
          0 && (
          <div className={'approval-area'}>
            <div className={'approval-header'}>
              <span className={'header-title'}>* Daily Approval</span>
              {!props.isReadOnly && (
                <div className={'approval-btn-area'}>
                  <div className={'approval-btn-up-down'}>
                    <button
                      className={'header-btn-up'}
                      onClick={() => {
                        moveUpApproval('DAILY');
                      }}
                    >
                      <img src={ButtonMoveUp} />
                    </button>
                    <button
                      className={'header-btn-down'}
                      onClick={() => {
                        moveDownApproval('DAILY');
                      }}
                    >
                      <img src={ButtonMoveDown} />
                    </button>
                  </div>
                  <button
                    className={'header-btn'}
                    onClick={() => {
                      resetApproval('DAILY');
                    }}
                  >
                    Reset
                  </button>
                  <button
                    className={'header-btn'}
                    onClick={() => {
                      delApproval();
                    }}
                  >
                    Deleted
                  </button>
                </div>
              )}
            </div>
            <div className={'approval-body'}>
              <table className={'form-table'}>
                <tbody>
                  {props.data?.approvalMVOList &&
                    props.data?.approvalMVOList
                      .filter((item: any) => item.approvalType == 'DAILY')
                      .map((approverItem: any, approverIndex: number) => (
                        <FormApprovalRow
                          key={getApprovalKey(approverItem) ?? approverIndex}
                          type={'DAILY'}
                          approverItem={approverItem}
                          data={props.data}
                          setData={props.setData}
                          checkedSeq={checkedSeq}
                          setCheckedSeq={setCheckedSeq}
                          isReadOnly={props.isReadOnly}
                          isFinish={props.isFinish}
                        />
                      ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

      {/*EXTEND 추가*/}
      {props.data?.approvalMVOList &&
        props.data?.approvalMVOList?.filter((item: any) => item.approvalType == 'EXTEND').length >
          0 && (
          <div className={'approval-area'}>
            <div className={'approval-header'}>
              <span className={'header-title'}>Extend Approval</span>
            </div>
            <div className={'approval-body'}>
              <table className={'form-table'}>
                <tbody>
                  {props.data?.approvalMVOList &&
                    props.data?.approvalMVOList
                      .filter((item: any) => item.approvalType == 'EXTEND')
                      .map((approverItem: any, approverIndex: number) => (
                        <FormApprovalRow
                          key={getApprovalKey(approverItem) ?? approverIndex}
                          type={'EXTEND'}
                          approverItem={approverItem}
                          data={props.data}
                          setData={props.setData}
                          checkedSeq={checkedSeq}
                          setCheckedSeq={setCheckedSeq}
                          isReadOnly={props.isReadOnly}
                          onRefresh={onRefresh}
                          isFinish={props.isFinish}
                        />
                      ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

      {props.data?.approvalMVOList &&
        props.data?.approvalMVOList?.filter((item: any) => item.approvalType == 'CLOSURE').length >
          0 && (
          <div className={'approval-area'}>
            <div className={'approval-header'}>
              <span className={'header-title'}>* Closing Approval</span>
              {!props.isReadOnly && (
                <div className={'approval-btn-area'}>
                  <div className={'approval-btn-up-down'}>
                    <button
                      className={'header-btn-up'}
                      onClick={() => {
                        moveUpApproval('CLOSURE');
                      }}
                    >
                      <img src={ButtonMoveUp} />
                    </button>
                    <button
                      className={'header-btn-down'}
                      onClick={() => {
                        moveDownApproval('CLOSURE');
                      }}
                    >
                      <img src={ButtonMoveDown} />
                    </button>
                  </div>
                  <button
                    className={'header-btn'}
                    onClick={() => {
                      resetApproval('CLOSURE');
                    }}
                  >
                    Reset
                  </button>
                  <button
                    className={'header-btn'}
                    onClick={() => {
                      delApproval();
                    }}
                  >
                    Deleted
                  </button>
                </div>
              )}
            </div>
            <div className={'approval-body'}>
              <table className={'form-table'}>
                <tbody>
                  {props.data?.approvalMVOList &&
                    props.data?.approvalMVOList
                      .filter((item: any) => item.approvalType == 'CLOSURE')
                      .map((approverItem: any, approverIndex: number) => (
                        <FormApprovalRow
                          key={getApprovalKey(approverItem) ?? approverIndex}
                          type={'CLOSURE'}
                          approverItem={approverItem}
                          data={props.data}
                          setData={props.setData}
                          checkedSeq={checkedSeq}
                          setCheckedSeq={setCheckedSeq}
                          isReadOnly={props.isReadOnly}
                          onRefresh={onRefresh}
                          isFinish={props.isFinish}
                        />
                      ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
    </div>
  );
};

export default FormApproval;
